import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.scss";
import Layout from "./components/Layout/Layout";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import Branches from "./pages/Branches/Branches";
import Service from "./pages/Service/Service";
import Movements from "./pages/Movements/Movements";
import { HelmetProvider } from "react-helmet-async";
import WelcomeToSweden from "./pages/WelcomeToSweden/WelcomeToSweden";

function App() {
  const location = useLocation();
  const lenisRef = useRef<Lenis | null>(null);
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
    });

    lenisRef.current = lenis;

    const syncScrollState = () => {
      if (document.body.classList.contains("stop")) {
        lenis.stop();
      } else {
        lenis.start();
      }
    };
    const bodyObserver = new MutationObserver(syncScrollState);

    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    syncScrollState();

    const raf = (time: number) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    return () => {
      bodyObserver.disconnect();
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    let observer: MutationObserver | null = null;

    // ✅ Only observe on specific route, e.g., "/movements"
    if (location.pathname === "/movements") {
      observer = new MutationObserver(() => {
        lenisRef.current?.resize();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }

    return () => {
      if (observer) observer.disconnect();
    };
  }, [location.pathname]);

  return (
    <HelmetProvider>
      <Routes>
        <Route path="/welcome-to-sweden" element={<WelcomeToSweden />} />
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/service" element={<Service />} />
          <Route path="/movements" element={<Movements />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}

export default App;
